import { isAuthenticatedSelector, selectAutoLoginUrl } from 'selectors/app'
import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'
import storage from 'util/storage'
import { trackPage } from 'util/tracking'
import { doSetOnboardingCompleteFlag } from 'subapps/onboarding/actions'
import { capture, stopRecording } from 'ducks/tracking/actions'

export function doRedirectIfAuthenticated() {
  return (_, getState) => {
    const state = getState()
    if (isAuthenticatedSelector(state)) {
      window.location = '/'
    }
  }
}

export function doFinishOnboarding() {
  return (dispatch, getState) => {
    const state = getState()
    const currentUser = selectCurrentUser(state)
    const autoLoginUrl = selectAutoLoginUrl(state)
    stopRecording()
    capture('user signed up')
    return Promise.all([
      trackPage('v4-completion', 'onboarding', currentUser?.id),
      dispatch(doSetOnboardingCompleteFlag()),
    ]).then(() => {
      if (storage.isAvailable()) {
        storage.cleanupAppStorage()
      }
      window.location = autoLoginUrl
    })
  }
}
